import { createSlice } from '@reduxjs/toolkit';
import { fetchSliderTexts } from '../actions/sliderTextsActions';

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const sliderTextsSlice = createSlice({
  name: 'sliderTexts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSliderTexts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSliderTexts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.error = null;
      })
      .addCase(fetchSliderTexts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'حدث خطأ أثناء جلب نصوص السلايدر';
      });
  },
});

export default sliderTextsSlice.reducer; 